export default __webpack_public_path__ + "static/lefafa_3_4-e0422b809f3385956464ad563484a47f.webp";